import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EscalafonPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EscalafonPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexEscalafon(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Escalafon', name: 'Escalafon', title: 'Escalafon' },
                { data: 'Descripcion', name: 'Descripcion', title: 'Descripcion' },
                { data: 'Activo', name: 'Activo', title: 'Activo' },
                //{ data: 'Rol', name: 'Rol', title: 'Rol' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            escalafons: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            escalafon: {},
            
        };
    },
    methods: {
                
        newEscalafon() {
            this.escalafon = {};
            this.$refs['frm-escalafon'].show();
            // console.log("hhhhola")
        },
        showEscalafon(id) {
            this.isLoading=true;
            this.ss.showEscalafon(id).then(
                (result) => {
                    let response = result.data;
                    this.escalafon = response.data;
                    this.$refs['view-escalafon'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEscalafon() {
            this.$refs['frm-escalafon'].show();
            this.$refs['view-escalafon'].hide();
        },
        cancelEscalafon() {
            if (this.escalafon.id) {
                this.$refs['view-escalafon'].show();
            }
            this.$refs['frm-escalafon'].hide();
        },
        saveEscalafon() {
            this.ss.storeEscalafon(this.escalafon).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-escalafon'].hide();
                    this.$refs['datatable-escalafon'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEscalafon() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyEscalafon(this.escalafon)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-escalafon'].hide();
                                this.$refs['datatable-escalafon'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-escalafon'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-escalafon'].show();
        },
        changePassword() {
            this.password.Escalafon = this.escalafon.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-escalafon'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-Escalafon').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEscalafon(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
